export default __webpack_public_path__ + "static/media/digital-signature.icon.452ab92e.svg";